import { createSelector } from 'reselect';

import { getState } from '../rootSelector';

export const getSelectedSegmentId = createSelector(getState, state => state.selectedSegmentId);
